import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import { SyncRunsSummary } from "../model/SyncRun";
import { GetSyncRunsSummaryRequest } from "../request";

const GetSyncRunsSummaryApiService = async (
  request: GetSyncRunsSummaryRequest
): Promise<SyncRunsSummary> => {
  const { data } = await axios.get<SyncRunsSummary>(
    "integrations/runs/summary/",
    { params: request }
  );
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useGetSyncRunsSummaryApiService = (request: GetSyncRunsSummaryRequest) =>
  useQuery<SyncRunsSummary, AxiosError>(
    ["GetSyncRunsSummaryApiService", ...Object.values(request)],
    () => GetSyncRunsSummaryApiService(request),
    { keepPreviousData: true }
  );
